import React from 'react';
import { createSvgIcon } from '@mui/material/utils';

const Logo = createSvgIcon(
  <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />,
  'Home',
);

export const CompassIcon = createSvgIcon(
  <svg viewBox="0 0 50 50">
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h50v50H0z" />
      <path
        fill="#021F2C"
        fillRule="nonzero"
        d="M25 4.167C13.494 4.167 4.167 13.494 4.167 25c0 11.506 9.327 20.833 20.833 20.833 11.506 0 20.833-9.327 20.833-20.833A20.833 20.833 0 0 0 25 4.167Zm0 37.5c-9.205 0-16.667-7.462-16.667-16.667 0-9.205 7.462-16.667 16.667-16.667 9.205 0 16.667 7.462 16.667 16.667A16.667 16.667 0 0 1 25 41.667Z"
      />
      <path
        fill="#021F2C"
        fillRule="nonzero"
        d="M32.667 17.333a2.083 2.083 0 0 0-2.292-.52l-8.77 3.541c-.522.212-.935.625-1.147 1.146l-3.645 8.875c-.264.71-.12 1.509.375 2.083h.104c.34.486.87.804 1.458.875.27.004.54-.046.792-.145l8.77-3.542c.521-.212.935-.625 1.146-1.146l3.646-8.875a2.083 2.083 0 0 0-.437-2.292ZM22.5 27.521l1.48-3.625 3.52-1.417-1.48 3.625-3.52 1.417Z"
      />
    </g>
  </svg>,
  'CompassIcon',
);

export const StarIcon = createSvgIcon(
  <svg viewBox="0 0 50 50">
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h50v50H0z" />
      <path
        fill="#021F2C"
        fillRule="nonzero"
        d="M36.583 43.75a2.083 2.083 0 0 1-.958-.23L25 37.959l-10.625 5.563a2.083 2.083 0 0 1-3.02-2.209l2.082-11.729-8.583-8.333a2.083 2.083 0 0 1-.52-2.083c.246-.756.9-1.305 1.687-1.417l11.875-1.73 5.229-10.687a2.083 2.083 0 0 1 3.75 0L32.167 16l11.875 1.73a2.083 2.083 0 0 1 1.687 1.416 2.083 2.083 0 0 1-.52 2.083l-8.584 8.334 2.083 11.729a2.083 2.083 0 0 1-.833 2.083 2.083 2.083 0 0 1-1.292.375ZM25 33.542c.334-.009.664.07.958.229l7.855 4.166-1.5-8.77a2.083 2.083 0 0 1 .604-1.855l6.25-6.104-8.75-1.291a2.083 2.083 0 0 1-1.48-1.167L25 10.937l-3.938 7.813a2.083 2.083 0 0 1-1.562 1.125l-8.75 1.292L17 27.27c.496.48.722 1.174.604 1.854l-1.5 8.667 7.854-4.167A1.917 1.917 0 0 1 25 33.542Z"
      />
    </g>
  </svg>,
  'StarIcon',
);

export const SmileyIcon = createSvgIcon(
  <svg viewBox="0 0 50 50">
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h50v50H0z" />
      <path
        fill="#021F2C"
        fillRule="nonzero"
        d="M25 4c11.598 0 21 9.402 21 21s-9.402 21-21 21S4 36.598 4 25 13.402 4 25 4Zm0 4.1C15.666 8.1 8.1 15.666 8.1 25S15.666 41.9 25 41.9 41.9 34.334 41.9 25 34.334 8.1 25 8.1Zm10.07 19.85a2.05 2.05 0 0 1 .484 2.858 12.954 12.954 0 0 1-10.579 5.464 12.953 12.953 0 0 1-10.515-5.376 2.05 2.05 0 1 1 3.322-2.403 8.854 8.854 0 0 0 7.193 3.679c2.91 0 5.581-1.41 7.237-3.74a2.05 2.05 0 0 1 2.858-.483ZM31.3 16.94a2.6 2.6 0 1 1 0 5.2 2.6 2.6 0 0 1 0-5.2Zm-12.6 0a2.6 2.6 0 1 1 0 5.2 2.6 2.6 0 0 1 0-5.2Z"
      />
    </g>
  </svg>,
  'SmileyIcon',
);

export const HatIcon = createSvgIcon(
  <svg viewBox="0 0 50 50">
    <g fill="none" fillRule="evenodd">
      <path d="M.003 0h50v50h-50z" />
      <path
        fill="#000"
        fillRule="nonzero"
        d="M28.503 9.12a8.175 8.175 0 0 0-7 0L1.194 18.743a2.083 2.083 0 0 0-1.191 1.991v12.609a2.083 2.083 0 0 0 4.166 0v-9.359l4.167 2.067v11.458c0 .554.22 1.085.613 1.475l.104.1.25.23a28.096 28.096 0 0 0 4.216 3.104c2.784 1.675 6.805 3.425 11.484 3.425s8.7-1.75 11.487-3.425c1.5-.902 2.911-1.94 4.217-3.105l.25-.229.096-.1h.008c.392-.392.61-.924.608-1.479V26.046l7.175-3.558a2.084 2.084 0 0 0-.033-3.75L28.503 9.117v.004Zm.133 23.397 8.867-4.4v8.466a23.93 23.93 0 0 1-3.154 2.263c-2.417 1.45-5.692 2.829-9.346 2.829s-6.925-1.375-9.346-2.83a23.93 23.93 0 0 1-3.154-2.262v-8.466l8.866 4.4a8.19 8.19 0 0 0 7.267 0Zm-1.917-19.63 16.425 7.78-16.362 8.116a4.008 4.008 0 0 1-3.558 0L6.86 20.667l16.425-7.78a4.008 4.008 0 0 1 3.433 0Z"
      />
    </g>
  </svg>,
  'HatIcon',
);

export const PaperplaneIcon = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    role="img"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 48 48"
  >
    <g fill="none" stroke="currentColor" strokeLinejoin="round" strokeWidth="4">
      <path d="M43 5L29.7 43l-7.6-17.1L5 18.3L43 5Z" />
      <path strokeLinecap="round" d="M43 5L22.1 25.9" />
    </g>
  </svg>,
  'PaperplaneIcon',
);

export const LampIcon = createSvgIcon(
  <svg viewBox="0 0 50 50" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g
      id="03_Karrierenavigator"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Karrierenavigator_05"
        transform="translate(-40.000000, -224.000000)"
      >
        <g id="Stacked-Group" transform="translate(20.000000, 204.000000)">
          <g id="eva:bulb-outline" transform="translate(20.000000, 20.000000)">
            <rect id="ViewBox" x="0" y="0" width="50" height="50"></rect>
            <path
              d="M25,14.5833333 C20.5163499,14.5833333 16.535737,17.4523968 15.1178823,21.7059608 C13.7000277,25.9595247 15.1630799,30.6431433 18.75,33.3333333 L18.75,41.6666667 C18.75,43.9678531 20.6154802,45.8333333 22.9166667,45.8333333 L27.0833333,45.8333333 C29.3845198,45.8333333 31.25,43.9678531 31.25,41.6666667 L31.25,33.3333333 C34.8369201,30.6431433 36.2999723,25.9595247 34.8821177,21.7059608 C33.464263,17.4523968 29.4836501,14.5833333 25,14.5833333 L25,14.5833333 Z M28.125,30.3958333 C27.4778454,30.7694603 27.0803667,31.4610734 27.0833333,32.2083333 L27.0833333,41.6666667 L22.9166667,41.6666667 L22.9166667,32.2083333 C22.9196333,31.4610734 22.5221546,30.7694603 21.875,30.3958333 C19.9464394,29.2823891 18.7559997,27.2268965 18.75,25 C18.75,21.5482203 21.5482203,18.75 25,18.75 C28.4517797,18.75 31.25,21.5482203 31.25,25 C31.2440003,27.2268965 30.0535606,29.2823891 28.125,30.3958333 L28.125,30.3958333 Z M25,12.5 C26.1505932,12.5 27.0833333,11.5672599 27.0833333,10.4166667 L27.0833333,6.25 C27.0833333,5.09940677 26.1505932,4.16666667 25,4.16666667 C23.8494068,4.16666667 22.9166667,5.09940677 22.9166667,6.25 L22.9166667,10.4166667 C22.9166667,11.5672599 23.8494068,12.5 25,12.5 Z M43.75,22.9166667 L39.5833333,22.9166667 C38.4327401,22.9166667 37.5,23.8494068 37.5,25 C37.5,26.1505932 38.4327401,27.0833333 39.5833333,27.0833333 L43.75,27.0833333 C44.9005932,27.0833333 45.8333333,26.1505932 45.8333333,25 C45.8333333,23.8494068 44.9005932,22.9166667 43.75,22.9166667 Z M10.4166667,22.9166667 L6.25,22.9166667 C5.09940677,22.9166667 4.16666667,23.8494068 4.16666667,25 C4.16666667,26.1505932 5.09940677,27.0833333 6.25,27.0833333 L10.4166667,27.0833333 C11.5672599,27.0833333 12.5,26.1505932 12.5,25 C12.5,23.8494068 11.5672599,22.9166667 10.4166667,22.9166667 Z M15.9583333,13.375 L12.9583333,10.4166667 C12.1126473,9.61700441 10.778829,9.65431403 9.97916671,10.5 C9.17950443,11.345686 9.21681401,12.6795044 10.0625,13.4791667 L13.0625,16.375 C13.4692738,16.7677782 14.018232,16.9783375 14.5833333,16.9583333 C15.1503909,16.9561693 15.6920649,16.7229485 16.0833333,16.3125 C16.8575625,15.4659311 16.8016819,14.1527358 15.9583333,13.375 L15.9583333,13.375 Z M39.9791667,10.5208333 C39.1665886,9.71307584 37.8542447,9.71307584 37.0416667,10.5208333 L34.0416667,13.375 C33.2339092,14.187578 33.2339092,15.499922 34.0416667,16.3125 C34.4329351,16.7229485 34.9746091,16.9561693 35.5416667,16.9583333 C36.0780615,16.9561972 36.5929635,16.7472515 36.9791667,16.375 L39.9791667,13.4791667 C40.373568,13.0879863 40.5954132,12.5554949 40.5954132,12 C40.5954132,11.4445051 40.373568,10.9120137 39.9791667,10.5208333 Z"
              id="Shape"
              fill="#021F2C"
              fillRule="nonzero"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>,
  'LampIcon',
);

export const HeartIcon = createSvgIcon(
  <svg viewBox="0 0 50 50" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g
      id="03_Karrierenavigator"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Karrierenavigator_05"
        transform="translate(-40.000000, -324.000000)"
      >
        <g id="Stacked-Group" transform="translate(20.000000, 204.000000)">
          <g id="Group-5" transform="translate(0.000000, 100.000000)">
            <g
              id="eva:heart-outline-copy"
              transform="translate(20.000000, 20.000000)"
            >
              <rect id="ViewBox" x="0" y="0" width="50" height="50"></rect>
              <path
                d="M25,43.7500349 C24.4462438,43.7532016 23.9139976,43.5358052 23.5208333,43.1458333 L7.33333333,26.9375 C3.10739684,22.6674049 3.10739684,15.7909284 7.33333333,11.5208333 C11.5940477,7.27214352 18.4892856,7.27214352 22.75,11.5208333 L25,13.7708333 L27.25,11.5208333 C31.5107144,7.27214352 38.4059523,7.27214352 42.6666667,11.5208333 C46.8926032,15.7909284 46.8926032,22.6674049 42.6666667,26.9375 L26.4791667,43.1458333 C26.0860024,43.5358052 25.5537562,43.7532016 25,43.7500349 Z M15.0416667,12.4999316 C13.2602816,12.4919351 11.5497645,13.1971484 10.2916667,14.4583333 C7.67232259,17.0914747 7.67232259,21.3460253 10.2916667,23.9791667 L25,38.7083333 L39.7083333,23.9791667 C42.3276774,21.3460253 42.3276774,17.0914747 39.7083333,14.4583333 C37.0424654,11.9397125 32.8742012,11.9397125 30.2083333,14.4583333 L26.4791667,18.2083333 C26.0879863,18.6027347 25.5554949,18.8245798 25,18.8245798 C24.4445051,18.8245798 23.9120137,18.6027347 23.5208333,18.2083333 L19.7916667,14.4583333 C18.5335689,13.1971484 16.8230517,12.4919351 15.0416667,12.4999316 Z"
                id="Shape"
                fill="#021F2C"
                fillRule="nonzero"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>,
  'HeartIcon',
);

export const CheckLabelIcon = createSvgIcon(
  <svg viewBox="0 0 80 80" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g
      id="03_Karrierenavigator"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Karrierenavigator_10"
        transform="translate(-148.000000, -227.000000)"
      >
        <g id="Group-3" transform="translate(113.000000, 192.000000)">
          <g transform="translate(35.000000, 35.000000)">
            <rect id="ViewBox" x="0" y="0" width="80" height="80"></rect>
            <path
              d="M37.5901933,3.26922738 C38.8748123,2.00644514 40.9058217,1.95967542 42.2457289,3.12891824 L42.3971848,3.26922738 L50.4725462,11.2068571 L61.76259,10.3176585 C63.4988244,10.1807436 65.0388756,11.3630836 65.3875028,13.0295721 L65.4202514,13.209939 L65.4449591,13.407533 L66.5274033,24.6788571 L75.749076,31.254787 C77.1593351,32.260386 77.5822337,34.1408088 76.7958621,35.6375442 L76.6997477,35.80847 L76.5838013,35.9887495 L70.1674033,45.32 L73.0052191,56.2838979 C73.4409913,57.9678294 72.5468833,59.6875528 70.97001,60.3222326 L70.792025,60.3882305 L70.6017233,60.4468747 L59.6874033,63.4708571 L54.8149003,73.693592 C54.0673378,75.2615136 52.2808774,76.0042914 50.6666991,75.4810919 L50.4881164,75.4177265 L50.2978059,75.3376799 L39.993689,70.6388571 L29.6895721,75.3376799 C28.1090655,76.0582536 26.263109,75.4789398 25.3628828,74.0405719 L25.2668111,73.8772404 L25.1724777,73.693592 L20.2988319,63.4708571 L9.38565469,60.4468747 C7.70944119,59.9822988 6.66717097,58.3481168 6.90595881,56.6651645 L6.93779551,56.4780261 L6.98215896,56.2838979 L9.81883187,45.32 L3.40357671,35.9887495 C2.42230171,34.5614586 2.66804957,32.6497993 3.91891077,31.512283 L4.06768885,31.3845383 L4.23830202,31.254787 L13.4588319,24.6788571 L14.5424189,13.407533 C14.709078,11.6739009 16.1408827,10.3625577 17.842592,10.3086096 L18.0259055,10.307679 L18.224788,10.3176585 L29.513689,11.2068571 L37.5901933,3.26922738 Z M39.993689,10.5222857 L33.206484,17.1938156 C32.548966,17.8401567 31.6612436,18.1923344 30.74525,18.176851 L30.5334569,18.1667179 L21.0451176,17.4182857 L20.1348556,26.8921805 C20.0538963,27.7343403 19.6652375,28.5113536 19.0518974,29.0794284 L18.8939295,29.217011 L18.7125676,29.3556556 L10.9628319,34.8811429 L16.355396,42.7238397 C16.831379,43.4161698 17.033617,44.2543333 16.9338746,45.0781993 L16.8991638,45.3024152 L16.8493515,45.5252002 L14.4645462,54.7382857 L23.6365565,57.2809841 C24.4518636,57.506953 25.1495824,58.0246342 25.6025215,58.7273014 L25.7105831,58.9067603 L25.8156281,59.1094423 L29.9114033,67.6994286 L38.571401,63.752164 C39.3305578,63.4060545 40.1844674,63.3507731 40.9738924,63.5863198 L41.1874717,63.6577705 L41.415977,63.752164 L50.0748319,67.6994286 L54.1717499,59.1094423 C54.5358624,58.3457606 55.1668364,57.7485362 55.9374806,57.4244951 L56.1329779,57.3492379 L56.3508216,57.2809841 L65.521689,54.7382857 L63.1380265,45.5252002 C62.9275397,44.7118271 63.0241669,43.8550415 63.3996729,43.1149747 L63.5089767,42.9161524 L63.631982,42.7238397 L69.0234033,34.8811429 L61.2748104,29.3556556 C60.5859582,28.8644628 60.1073744,28.1393678 59.9220773,27.3241622 L59.8819111,27.1185668 L59.8525224,26.8921805 L58.9411176,17.4182857 L49.4539211,18.1667179 C48.6104971,18.2332281 47.7777985,17.9854008 47.1118486,17.4800239 L46.9489254,17.3483469 L46.780894,17.1938156 L39.993689,10.5222857 Z M49.1135489,27.6059976 C50.2365279,26.1332382 52.3407896,25.8496852 53.8135489,26.9726642 C55.2337097,28.0555368 55.5480906,30.0508521 54.5618292,31.5125256 L54.4468823,31.6726642 L39.2135489,51.6726642 C38.5842403,52.4901542 37.6118711,52.9701845 36.5802156,52.9727604 C35.6226768,52.9778255 34.7127087,52.5711661 34.0784839,51.8624489 L33.9468823,51.7059976 L25.8468823,41.3393309 C24.7146985,39.8849811 24.9758658,37.7881813 26.4302156,36.6559976 C27.8326244,35.564249 29.8324133,35.7681035 30.9886256,37.0880826 L31.1135489,37.2393309 L36.5468823,44.2726642 L49.1468823,27.6059976 L49.1135489,27.6059976 Z"
              id="Shape"
              fill="#021F2C"
              fillRule="nonzero"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>,
  'CheckLabelIcon',
);

export const BookIcon = createSvgIcon(
  <svg viewBox="0 0 50 50" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g
      id="03_Karrierenavigator"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Karrierenavigator_05"
        transform="translate(-40.000000, -424.000000)"
      >
        <g id="Stacked-Group" transform="translate(20.000000, 204.000000)">
          <g id="Group-4" transform="translate(0.000000, 200.000000)">
            <g
              id="eva:book-open-outline"
              transform="translate(20.000000, 20.000000)"
            >
              <rect id="ViewBox" x="0" y="0" width="50" height="50"></rect>
              <path
                d="M42.9583333,8.79166667 C42.4681105,8.3951087 41.8246636,8.24190705 41.2083333,8.375 L25,12.0208333 L8.79166667,8.33333333 C8.16528389,8.19186441 7.50866235,8.34716639 7.01202125,8.75424926 C6.51538015,9.16133213 6.23422326,9.77470098 6.25,10.4166667 L6.25,35.8333333 C6.22572992,36.8263748 6.90593212,37.6984289 7.875,37.9166667 L24.5416667,41.6666667 L25.4583333,41.6666667 L42.125,37.9166667 C43.0940679,37.6984289 43.7742701,36.8263748 43.75,35.8333333 L43.75,10.4166667 C43.7470776,9.78276674 43.455703,9.18468206 42.9583333,8.79166667 Z M10.4166667,13.0208333 L22.9166667,15.8333333 L22.9166667,36.9791667 L10.4166667,34.1666667 L10.4166667,13.0208333 Z M39.5833333,34.1666667 L27.0833333,36.9791667 L27.0833333,15.8333333 L39.5833333,13.0208333 L39.5833333,34.1666667 Z"
                id="Shape"
                fill="#021F2C"
                fillRule="nonzero"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>,
  'BookIcon',
);

export const LogoIcon = () => {
  return (
    <svg viewBox="0 0 97 31">
      <defs>
        <path id="c" d="M0 0h4.845v4.844H0z" />
      </defs>
      <defs>
        <path id="a" d="M0 0h4.671v8.94H0z" />
        <path id="g" d="M0 0h35.868v3.614H0z" />
      </defs>
      <g fill="none" fullrule="evenodd">
        <path
          fill="#021F2C"
          d="M38.341 19.97a.607.607 0 0 1-.572-.376l-3.053-5.461v5.208c0 .341-.295.63-.643.63a.63.63 0 0 1-.63-.63v-7.668c0-.348.289-.643.63-.643.29 0 .52.166.602.435l3.035 5.449-.011-5.24c0-.343.3-.644.642-.644s.63.295.63.643l-.013 7.49c0 .261 0 .808-.617.808M45.103 19.97h-2.556c-.787 0-1.468-.383-1.793-.762-.253-.29-.549-.879-.549-1.58l-.012-4.255c0-.772.329-1.444.926-1.892.24-.17.74-.45 1.428-.45h2.556c.342 0 .63.294.63.642a.63.63 0 0 1-.63.63h-2.556c-.322 0-.488.053-.682.219-.281.218-.387.455-.387.85v4.256c0 .335.067.526.268.759.125.153.445.311.801.311h1.914v-2.983h-.725a.635.635 0 0 1-.46-.198.617.617 0 0 1-.17-.456c0-.336.283-.618.63-.618h1.367a.62.62 0 0 1 .444.179l.02.021a.63.63 0 0 1 .166.43v4.268c0 .145-.04.265-.128.389a.643.643 0 0 1-.502.24M22.579 19.97h-1.7c-.707 0-1.35-.273-1.767-.748-.398-.455-.575-.947-.575-1.594v-4.256c0-.725.319-1.429.833-1.837a2.38 2.38 0 0 1 1.51-.505h1.699c.341 0 .63.294.63.643a.63.63 0 0 1-.63.63h-1.7c-.312 0-.517.074-.73.265-.247.227-.34.445-.34.804v4.256c0 .35.065.534.265.754.192.203.478.316.805.316h1.7c.341 0 .63.294.63.642a.63.63 0 0 1-.63.63M29.059 19.97a.645.645 0 0 1-.643-.63v-3.625h-2.983v3.625c0 .341-.294.63-.643.63a.63.63 0 0 1-.63-.63v-7.667c0-.349.289-.643.63-.643.343 0 .643.3.643.643v2.77h2.983v-2.77c0-.343.3-.643.643-.643.341 0 .63.294.63.643v7.667a.63.63 0 0 1-.63.63M31.552 19.97a.63.63 0 0 1-.63-.63v-7.667c0-.348.289-.643.63-.643.343 0 .643.3.643.643v7.668c0 .341-.294.63-.643.63M4.042 19.97h-1.7c-.706 0-1.35-.273-1.766-.748C.177 18.767 0 18.275 0 17.628v-4.256c0-.725.32-1.429.833-1.837a2.379 2.379 0 0 1 1.51-.505h1.699c.341 0 .63.294.63.643a.63.63 0 0 1-.63.63h-1.7c-.312 0-.517.074-.73.265-.247.227-.34.445-.34.804v4.256c0 .35.065.534.266.754.19.203.478.316.804.316h1.7c.341 0 .63.294.63.642a.63.63 0 0 1-.63.63M8.093 19.97c-1.359 0-2.764-.876-2.764-2.342v-4.256c0-1.151 1.034-2.342 2.764-2.342 1.73 0 2.764 1.19 2.764 2.342v4.256c0 1.466-1.406 2.342-2.764 2.342m0-7.668c-.723 0-1.492.375-1.492 1.07v4.256c0 .702.75 1.07 1.492 1.07.741 0 1.491-.368 1.491-1.07v-4.256c0-.695-.768-1.07-1.491-1.07M17.243 19.97a.62.62 0 0 1-.61-.46l-.69-2.096h-2.5l-.706 2.107c-.074.222-.204.449-.606.449a.619.619 0 0 1-.503-.25.681.681 0 0 1-.105-.593l2.57-7.674a.628.628 0 0 1 .62-.423.58.58 0 0 1 .564.389l2.597 7.753a.571.571 0 0 1-.098.512.683.683 0 0 1-.533.286Zm-3.378-3.828h1.66l-.816-2.504-.844 2.504ZM61.76 19.97a.63.63 0 0 1-.63-.63v-7.667c0-.156 0-.35.174-.502.14-.14.316-.14.457-.14h3.412c.341 0 .63.294.63.642a.63.63 0 0 1-.63.63h-2.77v2.14h2.77a.63.63 0 0 1 .63.63.645.645 0 0 1-.63.642h-2.77v3.626c0 .341-.294.63-.642.63M69.519 19.97a2.767 2.767 0 0 1-2.764-2.763v-5.534c0-.348.288-.643.63-.643s.642.3.642.643v5.534c0 .822.67 1.491 1.492 1.491s1.491-.669 1.491-1.491v-5.534c0-.342.3-.643.643-.643.341 0 .63.295.63.643v5.534a2.767 2.767 0 0 1-2.764 2.764M75.691 19.97a.63.63 0 0 1-.63-.63v-7.037h-1.504a.63.63 0 0 1-.63-.63c0-.348.289-.643.63-.643h4.268c.341 0 .63.295.63.643a.63.63 0 0 1-.63.63h-1.504v7.038a.63.63 0 0 1-.63.63M81.863 19.97a2.767 2.767 0 0 1-2.764-2.763v-5.534c0-.348.289-.643.63-.643.342 0 .642.3.642.643v5.534c0 .822.67 1.491 1.492 1.491.823 0 1.492-.669 1.492-1.491v-5.534c0-.342.3-.643.642-.643s.63.295.63.643v5.534a2.767 2.767 0 0 1-2.764 2.764M90.76 19.97a.631.631 0 0 1-.552-.29l-.015-.022-1.692-3.1h-1.367v2.783c0 .341-.295.63-.643.63a.63.63 0 0 1-.63-.63v-7.643c0-.204.058-.36.176-.479a.577.577 0 0 1 .454-.188h2.134c1.51 0 2.75 1.239 2.764 2.762.013 1.163-.54 2.058-1.563 2.542l1.486 2.674a.647.647 0 0 1-.034.636c-.12.204-.315.326-.519.326ZM87.133 15.3h1.491a1.5 1.5 0 0 0 1.492-1.505c0-.822-.67-1.491-1.492-1.491h-1.491v2.996Z"
        />
        <g transform="translate(92.329 11.03)">
          <path
            fill="#021F2C"
            d="M4.08 8.94H.63a.564.564 0 0 1-.454-.176A.59.59 0 0 1 0 8.31V.643C0 .485.014.304.186.153.326.014.489 0 .629 0h3.413c.34 0 .63.294.63.643a.63.63 0 0 1-.63.63h-2.77v2.14h2.335a.637.637 0 0 1 .013 1.272H1.272v2.983h2.77c.34 0 .63.294.63.642 0 .353-.26.63-.592.63"
            mask="url(#b)"
          />
        </g>
        <path
          fill="#021F2C"
          d="M53.43 9.885a5.615 5.615 0 1 1 0 11.23 5.615 5.615 0 0 1 0-11.23Zm-.19 1.2h-.083c-.22.018-.474.165-.545.432l-1.728 6.017c-.052.225.034.504.189.62.12.103.241.172.435.172h2.348v1.07c0 .34.295.63.643.63a.63.63 0 0 0 .63-.63v-1.07h.647c.342 0 .63-.295.63-.643a.63.63 0 0 0-.63-.63h-.648v-1.082a.624.624 0 0 0-.63-.617.645.645 0 0 0-.642.63v1.07h-1.51l1.485-5.197a.62.62 0 0 0-.107-.533.616.616 0 0 0-.484-.238ZM58.173 9.407a4.004 4.004 0 1 0 0-8.008 4.004 4.004 0 0 0 0 8.008"
        />
        <g transform="translate(63.126)">
          <path
            fill="#021F2C"
            d="M2.422 4.844a2.423 2.423 0 1 0 0-4.845 2.423 2.423 0 0 0 0 4.845"
            mask="url(#d)"
          />
        </g>
        <path
          fill="#021F2C"
          d="M70.742 4.434a1.398 1.398 0 1 0 0-2.797 1.398 1.398 0 0 0 0 2.797M73.782 5.26a.717.717 0 1 0 0-1.434.717.717 0 0 0 0 1.434M48.685 21.593a4.004 4.004 0 1 0 0 8.007 4.004 4.004 0 0 0 0-8.007"
        />
        <g transform="translate(38.887 26.156)">
          <path
            fill="#021F2C"
            d="M2.422 0a2.422 2.422 0 1 0 0 4.845 2.422 2.422 0 0 0 0-4.845"
            mask="url(#f)"
          />
        </g>
        <path
          fill="#021F2C"
          d="M36.117 26.566a1.398 1.398 0 1 0 0 2.796 1.398 1.398 0 0 0 0-2.796M33.076 25.74a.717.717 0 1 0 0 1.434.717.717 0 0 0 0-1.434M95.813 29.316c-.343 0-.554-.313-.554-.67 0-.324.183-.707.554-.707.39 0 .582.339.582.733 0 .353-.238.644-.582.644Zm.949-1.614h-.34v.282h-.007c-.11-.205-.305-.327-.656-.327-.601 0-.89.52-.89 1.007 0 .491.28.933.85.933.255 0 .512-.096.669-.293h.007v.186c0 .402-.23.651-.617.651-.27 0-.437-.048-.718-.171l-.039.323c.32.104.503.13.714.13.715 0 1.027-.33 1.027-.907v-1.814Zm-3.513 1.895h.366v-.862c0-.476.215-.773.543-.773.063 0 .137.007.203.033v-.312c-.078-.015-.132-.026-.242-.026a.606.606 0 0 0-.519.338h-.008v-.293h-.343v1.895Zm-2.148-1.13c.028-.245.176-.528.535-.528.317 0 .496.238.496.529h-1.03Zm1.27.704c-.09.07-.371.189-.614.189-.347 0-.656-.256-.656-.632h1.421c0-.61-.214-1.07-.878-1.07-.562 0-.933.396-.933.958 0 .618.324 1.026 1.03 1.026.329 0 .489-.074.63-.122v-.35Zm-2.643-.529c.008.298-.157.718-.551.718-.414 0-.586-.39-.586-.706 0-.354.192-.715.59-.715.398 0 .555.361.547.703Zm-1.503.955h.35v-.267h.008c.098.141.324.312.68.312.601 0 .855-.505.855-1.026 0-.51-.281-.959-.86-.959-.347 0-.546.13-.659.305h-.008v-1.153h-.366v2.788Zm-3.709 0h.366v-.955c0-.353.149-.703.524-.703.297 0 .355.294.355.528v1.13h.367v-.955c0-.353.148-.703.523-.703.297 0 .356.294.356.528v1.13h.366v-1.215c0-.413-.183-.725-.69-.725-.18 0-.481.097-.618.368a.588.588 0 0 0-.565-.368c-.293 0-.493.1-.633.32h-.008v-.275h-.343v1.895Zm-2.144-1.13c.028-.245.176-.528.535-.528.317 0 .496.238.496.529h-1.03Zm1.27.704c-.09.07-.371.189-.613.189-.348 0-.657-.256-.657-.632h1.422c0-.61-.215-1.07-.879-1.07-.562 0-.933.396-.933.958 0 .618.324 1.026 1.03 1.026.329 0 .489-.074.63-.122v-.35ZM81.42 27.7h-.527v-.55l-.367.112v.439h-.449v.282h.449v1.108c0 .38.234.55.613.55.116 0 .23-.03.312-.052v-.297a.467.467 0 0 1-.25.067c-.168 0-.308-.119-.308-.338v-1.038h.527v-.282Zm-1.753 0h-.527v-.55l-.367.112v.439h-.449v.282h.45v1.108c0 .38.233.55.612.55.117 0 .23-.03.312-.052v-.297a.464.464 0 0 1-.25.067c-.168 0-.308-.119-.308-.338v-1.038h.527v-.282Zm-2.81 1.896h.366v-.862c0-.476.215-.773.543-.773.062 0 .136.007.203.033v-.312c-.078-.015-.133-.026-.242-.026a.606.606 0 0 0-.52.338H77.2v-.293h-.343v1.895Zm-.86-1.895h-.366v.877c0 .461-.188.78-.606.78-.32-.018-.421-.233-.421-.676v-.981h-.367v1.127c0 .509.23.813.746.813.277 0 .542-.13.652-.345h.008v.3h.354v-1.895Zm-.74-.29h.365v-.372h-.366v.372Zm-.641 0h.366v-.372h-.366v.372Zm-3.998 2.185h.523l.597-2.267h.008l.594 2.267h.503l.84-2.594h-.414l-.652 2.223h-.008l-.59-2.223h-.554l-.582 2.223h-.007l-.652-2.223h-.43l.824 2.594Zm-2.217-.859h1.002v-.282h-1.002v.282Zm-2.456.86h.367v-.878c0-.461.187-.78.605-.78.32.018.422.234.422.676v.981h.367v-1.126c0-.51-.23-.814-.746-.814-.277 0-.543.13-.652.346H66.3v-.301h-.355v1.895Zm-2.147-1.13c.027-.246.176-.529.535-.529.316 0 .496.238.496.529h-1.031Zm1.269.703c-.09.07-.371.189-.613.189-.348 0-.656-.256-.656-.632h1.42c0-.61-.214-1.07-.877-1.07-.563 0-.933.396-.933.958 0 .618.323 1.026 1.03 1.026.329 0 .488-.074.629-.122v-.35Zm-3.889-.529c-.008-.346.149-.703.547-.703s.59.361.59.715c0 .315-.172.706-.586.706-.395 0-.559-.42-.55-.718Zm1.152.955h.351V26.81h-.366v1.153h-.008c-.113-.175-.313-.305-.66-.305-.578 0-.859.45-.859.96 0 .516.254 1.025.855 1.025.355 0 .582-.17.68-.312h.007v.267Zm-2.63-.735c0 .282-.192.498-.555.498-.168 0-.372-.108-.372-.309 0-.334.493-.364.692-.364.078 0 .156.007.234.007v.168Zm-1.07-.73a.964.964 0 0 1 .577-.193c.367 0 .492.168.492.495-.144-.007-.246-.007-.39-.007-.38 0-.926.148-.926.624 0 .413.3.591.73.591a.75.75 0 0 0 .617-.29h.008v.245h.344a2.725 2.725 0 0 1-.017-.37v-.785c0-.517-.23-.785-.8-.785-.253 0-.472.074-.655.178l.02.298Zm-2.332-.825h.41c.227 0 .504.078.504.387 0 .383-.32.417-.698.417h-.216v-.804Zm0 1.108h.255c.335 0 .706.056.706.458 0 .35-.316.42-.668.42h-.293v-.878Zm-.39 1.182h.726c.555 0 1.039-.133 1.039-.69 0-.365-.261-.596-.632-.625v-.008c.343-.081.561-.26.561-.617 0-.48-.39-.654-.956-.654h-.738v2.594Z"
        />
        <g transform="translate(61.132 22.284)">
          <path
            fill="#021F2C"
            d="M34.084 2.788h.367v-.974l.89.974h.527l-1.042-1.056.925-.84h-.5l-.8.77V0h-.367v2.788Zm-1.752 0h.366v-.863c0-.475.215-.773.543-.773a.57.57 0 0 1 .203.033V.874c-.078-.015-.133-.026-.242-.026a.606.606 0 0 0-.52.337h-.007V.892h-.343v1.896Zm-2.148-1.13c.027-.245.176-.528.535-.528.317 0 .496.238.496.528h-1.03Zm1.27.703c-.09.07-.372.19-.614.19-.347 0-.656-.257-.656-.633h1.421c0-.61-.214-1.07-.878-1.07-.562 0-.933.397-.933.959 0 .617.324 1.026 1.03 1.026.329 0 .489-.075.63-.123v-.35ZM29.332.892h-.359l-.484 1.57h-.008l-.5-1.57h-.433l-.507 1.57h-.008l-.457-1.57h-.402l.64 1.896h.426l.503-1.591h.008l.516 1.591h.425l.64-1.896ZM24.11 2.788h1.616v-.282h-1.19l1.147-1.31V.893h-1.518v.282h1.093l-1.148 1.31v.304ZM23.56.892h-.528v-.55l-.366.112v.438h-.45v.282h.45v1.109c0 .379.233.55.612.55.117 0 .23-.03.312-.052v-.297a.469.469 0 0 1-.25.067c-.167 0-.308-.12-.308-.339V1.174h.527V.892Zm-3.206.766c.027-.245.176-.528.536-.528.316 0 .495.238.495.528h-1.03Zm1.27.703c-.09.07-.371.19-.614.19-.348 0-.656-.257-.656-.633h1.421c0-.61-.215-1.07-.878-1.07-.562 0-.933.397-.933.959 0 .617.324 1.026 1.03 1.026.329 0 .49-.075.63-.123v-.35Zm-4.147.427h.367v-.877c0-.461.187-.781.606-.781.32.018.42.234.42.676v.982h.368V1.661c0-.509-.23-.813-.746-.813-.277 0-.543.13-.652.345h-.008v-.3h-.355v1.895Zm-1.92-.06c.168.086.358.105.546.105.356 0 .695-.186.695-.591 0-.606-.863-.495-.863-.882 0-.156.164-.23.352-.23.086 0 .304.048.386.096l.031-.304a1.61 1.61 0 0 0-.456-.074c-.395 0-.703.189-.703.583 0 .532.863.502.863.848 0 .205-.208.272-.375.272-.106 0-.312-.045-.457-.134l-.02.312Zm-1.64-.222c-.344 0-.555-.313-.555-.67 0-.323.184-.706.555-.706.39 0 .582.338.582.733 0 .353-.238.643-.582.643Zm.949-1.614h-.34v.282h-.008c-.109-.204-.304-.326-.656-.326-.601 0-.89.52-.89 1.007 0 .491.281.933.851.933.254 0 .512-.097.668-.293h.008v.186c0 .401-.23.65-.617.65-.27 0-.438-.048-.718-.17l-.04.323c.32.103.504.13.715.13.715 0 1.027-.331 1.027-.908V.892Zm-4.38 1.896h.366v-.877c0-.461.188-.781.606-.781.32.018.422.234.422.676v.982h.366V1.661c0-.509-.23-.813-.745-.813-.278 0-.543.13-.652.345h-.009v-.3h-.354v1.895ZM9.626.892H9.26v.878c0 .46-.188.78-.605.78-.32-.018-.422-.234-.422-.676V.892h-.367V2.02c0 .51.23.814.746.814.277 0 .543-.13.652-.346h.008v.301h.354V.892Zm-4.122.94c-.008-.345.149-.702.547-.702.399 0 .59.36.59.714 0 .316-.173.707-.586.707-.395 0-.559-.42-.551-.718Zm1.152.956h.351V0h-.366v1.152h-.008C6.52.978 6.32.848 5.973.848c-.578 0-.859.45-.859.959 0 .517.254 1.026.855 1.026.355 0 .582-.171.68-.312h.007v.267Zm-2.682 0h.366V0h-.366v2.788ZM2.63.468h.414V.074H2.63v.394Zm.024 2.32h.366V.892h-.366v1.896ZM.39.498H.8c.227 0 .504.078.504.387 0 .383-.32.416-.7.416H.39V.498Zm0 1.108h.254c.335 0 .707.056.707.457 0 .35-.317.42-.668.42H.39v-.877ZM0 2.788h.726c.555 0 1.038-.134 1.038-.691 0-.365-.261-.595-.632-.625v-.007c.344-.082.562-.26.562-.618 0-.48-.39-.654-.956-.654H0v2.595Z"
            mask="url(#h)"
          />
        </g>
      </g>
    </svg>
  );
};

export const RatingActive = createSvgIcon(
  <svg viewBox="0 0 85 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g
      id="03_Karrierenavigator"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
    >
      <g
        id="Karrierenavigator_07"
        transform="translate(-145.000000, -471.000000)"
        stroke="#021F2C"
        strokeWidth="4"
      >
        <g id="Group-6" transform="translate(20.000000, 453.000000)">
          <g id="Path-4" transform="translate(127.800000, 19.566987)">
            <line x1="70.2" y1="10.4330127" x2="80.2" y2="10.4330127"></line>
            <line
              x1="-3.36311036e-18"
              y1="10.4330127"
              x2="10"
              y2="10.4330127"
              id="Path-4-Copy-3"
              transform="translate(5.000000, 10.433013) scale(-1, 1) translate(-5.000000, -10.433013) "
            ></line>
            <line
              x1="7.66506351"
              y1="1.6830127"
              x2="12.6650635"
              y2="1.6830127"
              id="Path-4-Copy-4"
              transform="translate(10.165064, 1.683013) scale(-1, 1) rotate(-30.000000) translate(-10.165064, -1.683013) "
            ></line>
            <line
              x1="7.66506351"
              y1="19.1830127"
              x2="12.6650635"
              y2="19.1830127"
              id="Path-4-Copy-5"
              transform="translate(10.165064, 19.183013) rotate(-30.000000) translate(-10.165064, -19.183013) "
            ></line>
            <line
              x1="67.5349365"
              y1="1.6830127"
              x2="72.5349365"
              y2="1.6830127"
              id="Path-4-Copy"
              transform="translate(70.034936, 1.683013) rotate(-30.000000) translate(-70.034936, -1.683013) "
            ></line>
            <line
              x1="67.5349365"
              y1="19.1830127"
              x2="72.5349365"
              y2="19.1830127"
              id="Path-4-Copy-2"
              transform="translate(70.034936, 19.183013) scale(-1, 1) rotate(-30.000000) translate(-70.034936, -19.183013) "
            ></line>
          </g>
        </g>
      </g>
    </g>
  </svg>,
  'RatingActive',
);

export const Rating_1 = createSvgIcon(
  <svg viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g
      id="03_Karrierenavigator"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Karrierenavigator_07"
        transform="translate(-168.000000, -268.000000)"
        stroke="#021F2C"
      >
        <g id="Group-5" transform="translate(168.000000, 268.000000)">
          <rect
            id="Rectangle"
            strokeWidth="3.04"
            x="1.52"
            y="1.52"
            width="36.96"
            height="36.96"
            rx="18.48"
          ></rect>
          <g
            id="Group-4"
            transform="translate(12.000000, 12.800000)"
            fill="#021F2C"
            strokeWidth="0.5"
          >
            <circle id="Oval" cx="14" cy="2" r="2"></circle>
            <circle id="Oval-Copy" cx="2" cy="2" r="2"></circle>
          </g>
          <path
            d="M28.4596362,28.7113813 C26.5703639,26.0994219 23.4972858,24.4 20.0272865,24.4 C16.5259243,24.4 13.4286907,26.1302806 11.544,28.7824276"
            id="Oval"
            strokeWidth="3.04"
            strokeLinecap="round"
          ></path>
          <line
            x1="11.544"
            y1="28.7824276"
            x2="28.4596362"
            y2="28.7824276"
            id="Path-2"
            strokeWidth="3.04"
            strokeLinecap="round"
          ></line>
        </g>
      </g>
    </g>
  </svg>,
  'Rating_1',
);

export const Rating_2 = createSvgIcon(
  <svg viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g
      id="03_Karrierenavigator"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Karrierenavigator_07"
        transform="translate(-168.000000, -333.000000)"
        stroke="#021F2C"
      >
        <g id="Stacked-Group" transform="translate(168.000000, 268.000000)">
          <g id="Group-5-Copy" transform="translate(0.000000, 65.000000)">
            <rect
              id="Rectangle"
              strokeWidth="3.04"
              x="1.52"
              y="1.52"
              width="36.96"
              height="36.96"
              rx="18.48"
            ></rect>
            <g
              id="Group-4"
              transform="translate(12.000000, 12.800000)"
              fill="#021F2C"
              strokeWidth="0.5"
            >
              <circle id="Oval" cx="14" cy="2" r="2"></circle>
              <circle id="Oval-Copy" cx="2" cy="2" r="2"></circle>
            </g>
            <path
              d="M28.4596362,28.7113813 C26.5703639,26.0994219 23.4972858,24.4 20.0272865,24.4 C16.5259243,24.4 13.4286907,26.1302806 11.544,28.7824276"
              id="Oval"
              strokeWidth="3.04"
              strokeLinecap="round"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>,
  'Rating_2',
);

export const Rating_3 = createSvgIcon(
  <svg viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g
      id="03_Karrierenavigator"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Karrierenavigator_07"
        transform="translate(-168.000000, -398.000000)"
        stroke="#021F2C"
      >
        <g id="Stacked-Group" transform="translate(168.000000, 268.000000)">
          <g id="Group-5-Copy-2" transform="translate(0.000000, 130.000000)">
            <rect
              id="Rectangle"
              strokeWidth="3.04"
              x="1.52"
              y="1.52"
              width="36.96"
              height="36.96"
              rx="18.48"
            ></rect>
            <g
              id="Group-4"
              transform="translate(12.000000, 12.800000)"
              fill="#021F2C"
              strokeWidth="0.5"
            >
              <circle id="Oval" cx="14" cy="2" r="2"></circle>
              <circle id="Oval-Copy" cx="2" cy="2" r="2"></circle>
            </g>
            <line
              x1="26.8596362"
              y1="27.1113813"
              x2="13.144"
              y2="27.1824276"
              id="Oval"
              strokeWidth="3.04"
              strokeLinecap="round"
            ></line>
          </g>
        </g>
      </g>
    </g>
  </svg>,
  'Rating_3',
);

export const Rating_4 = createSvgIcon(
  <svg viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g
      id="03_Karrierenavigator"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Karrierenavigator_06"
        transform="translate(-168.000000, -463.000000)"
        stroke="#021F2C"
      >
        <g id="Stacked-Group" transform="translate(168.000000, 268.000000)">
          <g id="Group-5-Copy-3" transform="translate(0.000000, 195.000000)">
            <rect
              id="Rectangle"
              strokeWidth="3.04"
              x="1.52"
              y="1.52"
              width="36.96"
              height="36.96"
              rx="18.48"
            ></rect>
            <g
              id="Group-4"
              transform="translate(12.000000, 12.800000)"
              fill="#021F2C"
              strokeWidth="0.5"
            >
              <circle id="Oval" cx="14" cy="2" r="2"></circle>
              <circle id="Oval-Copy" cx="2" cy="2" r="2"></circle>
            </g>
            <path
              d="M28.4596362,28.7113813 C26.5703639,26.0994219 23.4972858,24.4 20.0272865,24.4 C16.5259243,24.4 13.4286907,26.1302806 11.544,28.7824276"
              id="Oval"
              strokeWidth="3.04"
              strokeLinecap="round"
              transform="translate(20.001818, 26.591214) rotate(180.000000) translate(-20.001818, -26.591214) "
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>,
  'Rating_4',
);

export const Rating_5 = createSvgIcon(
  <svg viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g
      id="03_Karrierenavigator"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Karrierenavigator_07"
        transform="translate(-168.000000, -528.000000)"
        stroke="#021F2C"
      >
        <g id="Stacked-Group" transform="translate(168.000000, 268.000000)">
          <g id="Group-5-Copy-4" transform="translate(0.000000, 260.000000)">
            <rect
              id="Rectangle"
              strokeWidth="3.04"
              x="1.52"
              y="1.52"
              width="36.96"
              height="36.96"
              rx="18.48"
            ></rect>
            <g
              id="Group-4"
              transform="translate(12.000000, 12.800000)"
              fill="#021F2C"
              strokeWidth="0.5"
            >
              <circle id="Oval" cx="14" cy="2" r="2"></circle>
              <circle id="Oval-Copy" cx="2" cy="2" r="2"></circle>
            </g>
            <path
              d="M28.4596362,28.7113813 C26.5703639,26.0994219 23.4972858,24.4 20.0272865,24.4 C16.5259243,24.4 13.4286907,26.1302806 11.544,28.7824276"
              id="Oval"
              strokeWidth="3.04"
              strokeLinecap="round"
              transform="translate(20.001818, 26.591214) rotate(180.000000) translate(-20.001818, -26.591214) "
            ></path>
            <line
              x1="11.544"
              y1="24.4"
              x2="28.4596362"
              y2="24.4"
              id="Path-3"
              strokeWidth="3.04"
              strokeLinecap="round"
            ></line>
          </g>
        </g>
      </g>
    </g>
  </svg>,
  'Rating_5',
);

export const CloseIcon = createSvgIcon(
  <svg viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g
      id="03_Karrierenavigator"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fullrule="evenodd"
    >
      <g
        id="Karrierenavigator_04"
        transform="translate(-336.000000, -33.000000)"
        stroke="#021F2C"
        strokeWidth="1.95652174"
      >
        <g id="Group" transform="translate(337.000000, 34.000000)">
          <line
            x1="0.428571429"
            y1="0.428571429"
            x2="17.5714286"
            y2="17.5714286"
            id="Line"
          ></line>
          <line
            x1="0.428571429"
            y1="0.428571429"
            x2="17.5714286"
            y2="17.5714286"
            id="Line"
            transform="translate(9.000000, 9.000000) scale(-1, 1) translate(-9.000000, -9.000000) "
          ></line>
        </g>
      </g>
    </g>
  </svg>,
  'CloseIcon',
);

export default Logo;
